module.exports = "<manual-invoice-item-page></manual-invoice-item-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/manualInvoiceItemView.html
// module id = 2170
// module chunks = 0